import * as baseDefs from './base';
import * as defaultsDefs from './defaults';
import * as mobileDefs from './mobile';
import * as motionDefs from './motion';
import * as transitionDefs from './transitions';

import { AnimationsDefinitions } from '../types';

function generateDefs<T extends { name: string }>(
  defs: Record<T['name'], T>,
  baseToExtend: Record<T['name'], T>,
) {
  const defsArray = [...Object.values(defs)] as T[];
  return defsArray.reduce<Record<T['name'], T>>(
    (acc, def) => {
      acc[def.name as T['name']] = def;
      return acc;
    },
    { ...baseToExtend } as Record<T['name'], T>,
  );
}

const base = generateDefs(baseDefs, {});
const transitions = generateDefs(transitionDefs, base);
const defaults = generateDefs(defaultsDefs, transitions);
const mobile = generateDefs(mobileDefs, defaults);
const motion = generateDefs(motionDefs, base);

export const definitions: AnimationsDefinitions = {
  defaults: defaults as AnimationsDefinitions['defaults'],
  mobile: mobile as AnimationsDefinitions['mobile'],
  motion: motion as AnimationsDefinitions['motion'],
};
